import { ColorSchemeStorage } from '@captrice/dreamer';

function setColorScheme(scheme) {
  document.querySelector('html').setAttribute('data-theme', scheme);
  const logo = document.getElementById('logo-img');
  const colorSchemeSwitch = document.getElementById('color-scheme-switch');
  if (scheme === 'dark') {
    logo.src = 'https://www.captrice.io/logo-dark.png';
    colorSchemeSwitch.classList.remove('fa-moon');
    colorSchemeSwitch.classList.add('fa-sun');
    colorSchemeSwitch.classList.add('has-text-warning');
  } else {
    logo.src = 'https://www.captrice.io/logo.png';
    colorSchemeSwitch.classList.remove('fa-sun');
    colorSchemeSwitch.classList.remove('has-text-warning');
    colorSchemeSwitch.classList.add('fa-moon');
  }
}

document.addEventListener('DOMContentLoaded', function() {
  const colorSchemeStorage = new ColorSchemeStorage('color-scheme', 'light');
  setColorScheme(colorSchemeStorage.retrieve());

  const colorSchemeSwitch = document.getElementById('color-scheme-switch');
  colorSchemeSwitch.addEventListener('click', function() {
    const oldScheme = document.querySelector('html').getAttribute('data-theme');
    const newScheme = oldScheme === 'light' ? 'dark' : 'light';
    setColorScheme(newScheme);
    colorSchemeStorage.store(newScheme);
  });

  const btnToggleNavbar = document.getElementById('btn-mob-navmenu-toggle');
  const navMenu = document.getElementById('navMenu');
  btnToggleNavbar.addEventListener('click', function() {
    const isVisible = navMenu.classList.contains('is-active');
    if (isVisible) {
      navMenu.classList.remove('is-active');
    } else {
      navMenu.classList.add('is-active');
    }
  });
});
